function formataNumero(number, decimals, dec_point, thousands_sep) {
  decimals = typeof decimals !== "undefined" ? decimals : 2;
  dec_point = typeof dec_point !== "undefined" ? dec_point : ",";
  thousands_sep = typeof thousands_sep !== "undefined" ? thousands_sep : ".";

  number = (number + "").replace(/[^0-9+\-Ee.]/g, "");

  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    s = "",
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec);
      return "" + (Math.round(n * k) / k).toFixed(prec);
    };

  s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
}

function valorBR(valor, decimais) {
  valor = parseFloat(valor);
  decimais = typeof decimais !== "undefined" ? decimais : 2;
  if (typeof valor == "number") {
    return formataNumero(valor, decimais, ",", ".");
  }

  if (typeof valor == "string") {
    valor = valor.replace(".", "").replace(",", ".");
    valor = parseFloat(valor).toFixed(2);
    return formataNumero(valor, 2, ",", ".");
  }
}

function valorUS(valor, decimais) {
  valor = typeof valor !== "undefined" ? valor : "0";
  decimais = typeof decimais !== "undefined" ? decimais : 2;

  if (typeof valor === "number") {
    return parseFloat(valor.toFixed(decimais));
  }

  valor = valor.replace(/[.]/g, "").replace(",", ".");
  valor = formataNumero(valor, decimais, ".", "");

  return parseFloat(valor);
}

export default {
  methods: {
    clone(object) {
      return JSON.parse(JSON.stringify(object));
    },

    valorUS,

    valorBR,

    hexToRgbA(hex, transparency) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          transparency +
          ")"
        );
      }
      throw new Error("Bad Hex");
    },
  },

  filters: {
    dataBR(date) {
      if (!date) return null;
      const [year, month, day] = date.split(/[-/]/);
      return `${day}/${month}/${year}`;
    },

    dataUS(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    valorBR,

    valorUS,

    highlight: function(value, query) {
      if (!query || !query.trim()) return value;
      return value.replace(
        new RegExp(query, "ig"),
        (v) => "<span class='highlight'>" + v + "</span>"
      );
    },
  },
};
